import React, {Component} from 'react';

import './TotalUse.css'

export default class TotalUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      units: [],
      usage: [],
    }
  }
  async componentDidMount() {
    const state = this.propsToTotals()
    if (state)
      this.setState ({units: state[0], usage: state[1]})
  }
  async componentDidUpdate() {
    const state = this.propsToTotals()
    if (state) {
      const newval = state[1].reduce ((prev, current) => prev+current, 0)
      const oldval = this.state.usage.reduce((prev, current) => prev+current, 0)
      if (oldval !== newval)
        this.setState({units: state[0], usage: state[1]})
    }
  }

  propsToTotals() {
    if (this.props?.data) {
      const sensors = this.filterTranscievers (this.props)
      const allUnits = this.uniqueUnits (sensors)
      const allUsage = this.summarize (sensors, allUnits)
      //console.log (sensors, allUnits, allUsage)
      return ([allUnits, allUsage])  
    }
    return null
  }
  filterTranscievers (devices) {
    return devices.data.filter ((dev) => 
      !dev.Type || !(dev.Type.toUpperCase() === 'DCAP' || dev.Type.toUpperCase() === 'RPTR'))
  }
  uniqueUnits(devices) {
    const units1 = devices.map(item => item.units1)
    const units2 = devices.map(item => item.units2)
    return [...new Set(units1.concat(units2))]
  }
  sanitize (x) {
    const sketchy = Number(x)
    return isNaN(sketchy) ? 0 : Math.round(sketchy)
  }
  summarize (sensors, allUnits) {
    let result = new Array (allUnits.length).fill(0)
    sensors.map ((device) => result[allUnits.indexOf (device.units1)] += this.sanitize(device?.Consumed1))
    sensors.map ((device) => result[allUnits.indexOf (device.units2)] += this.sanitize(device?.Consumed2))
    return result
  }
  readablize (unit) {
    let r = unit ?? "Not Available";
    r = r.length < 1 ? "Blank" : r
    let unit_no_underscore = r.replace(/_/g, " ");
    return unit_no_underscore
  }
  renderTotal () {
    return (
      this.state.usage.map((u, index) => u > 0 ? 
        <div key={index}> {this.readablize (this.state.units[index])}: {u} </div> :
        <div key={index}></div>)
      )
  }
  render() {
    return (
      <div className="total-container">
        <div className="tot-title">Total Consumption</div>
        <div className="tot-units">{this.renderTotal()}</div>
      </div>
    )
  }
}
